module.exports = __webpack_public_path__ + "img/user-face.ba8c4123.png";